import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { autobind } from 'core-decorators';
import Icon from 'utils/components/icon';
import Modal from 'utils/components/modal';
import classnames from 'classnames';
import changeCurrentSpotAction from '../../../../actions/spot/spot-change';
import ConfirmModal from '../../../modals/confirm';
import { connect } from 'react-redux';

class SpotSelectorItem extends Component {
  static displayName = 'SpotSelectorItem';

  static propTypes = {
    spotName: PropTypes.string.isRequired,
    spotType: PropTypes.string,
    spotId: PropTypes.string.isRequired,
    networkId: PropTypes.string.isRequired,
    closeSpotSelector: PropTypes.func.isRequired,
    currentUserId: PropTypes.string
  };

  static contextTypes = {
    executeAction: PropTypes.func.isRequired,
    getStore: PropTypes.func.isRequired
  };

  @autobind
  async handleItemClick() {
    const { spotId, networkId } = this.props;
    this.props.closeSpotSelector();
    await context.executeAction(changeCurrentSpotAction, { spotId, networkId });
  }

  @autobind
  closeConfirmationModal() {
    this.refs.deleteSpotModal.hide();
  }

  @autobind
  openConfirmModal(event) {
    this.refs.deleteSpotModal.show();
    event.stopPropagation();
  }

  @autobind
  unassignMe(event) {
    var { spotType, spotId, currentUserId } = this.props;

    this.context.executeAction(removeMeAction, {
      userId: currentUserId,
      spotType,
      spotId
    });

    this.refs.deleteSpotModal.hide();
    event.stopPropagation();
  }

  render() {
    var { spotName, isSelected } = this.props;
    var className = classnames('spot-item', 'item', { selected: isSelected });

    return (
      <div className={className} onClick={this.handleItemClick}>
        <div className="item-text">{spotName}</div>
        <span className="right-side" onClick={this.openConfirmModal}>
          <Icon name="trash" className="trash-icon" />
        </span>
        <Modal ref="deleteSpotModal" className="confirm-modal">
          <ConfirmModal
            onClose={this.closeConfirmationModal}
            title="Confirm Action"
            onConfirm={this.unassignMe}
            description="This site will be deleted permanently from your list. You can’t undo this action. Are you sure?"
            buttonName="Delete"
          />
        </Modal>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return { currentUserId: state.currentUser.id };
}

export default connect(mapStateToProps)(SpotSelectorItem);
